// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

/*jshint multistr: true */

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.834Z
*/
var module; UMD(module, {
  'minted:m': ['M']
})(this, function (m_module) {

var M = m_module.M;

M.Template = M.Template || {};

M.Template.WeddingVirality = {

  /**
   * Renders a dialog containing copy recommending that the customer
   * adds our logo to the back of their card.
   *
   * @param {string} dialogContent - HTML content for the body of the dialog.
   */
  LogoDescriptionDialog: '\
    <div class="grid_5"> \
      <img class="popupImg" src="//<@= M.MINTEDCDN_HTTP_HOST @><@= logo_example @>" \
        alt="Print the Minted logo on your card\'s backer." /> \
    </div> \
    <div class="grid_5" style="padding-top: 30px"> \
      <div class="popupContent"> \
        <h1 class="popupTitle text--secondary <@= titleClass @>"><@= title @></h1> \
        <@= designer_block @> \
        <p class="text--light popupBody"><@=  M.html.htmlAttributeEscape(body)  @></p> \
        <ul class="inline"> \
          <li> \
            <a class="cancelButton button buttonMedium buttonFlat buttonGhostColored"> \
              cancel \
            </a> \
          </li> \
          <li> \
            <a class="printLogoButton button buttonMedium buttonFlat buttonPrimary popupPrimaryButton"> \
              <@= M.html.htmlAttributeEscape(buttonText) @> \
            </a> \
          </li> \
        </ul> \
      </div> \
    </div> \
  ',

  MobileLogoDescriptionDialog: '\
    <img src="//<@= M.MINTEDCDN_HTTP_HOST @>/files/content/wedding_virality/dialog_logo_example.png" \
      alt="Print the Minted logo on your card\'s backer." /> \
    <h1 class="emphasis"><@= title @></h1> \
    <p class="intro"><@= body @></p> \
    <ul class="inline"> \
      <li> \
        <a class="printLogoButton button"> \
          <@= buttonText @> \
          <img src="<@= M.img_src(\'/static/images/sprite_placeholder.png\') @>"  \
            class="sprite buttonArrowIcon" /> \
        </a> \
      </li> \
      <li> \
        <a class="cancelButton button button-ghost button-ghost button-last"> \
          no thanks \
        </a> \
      </li> \
    </ul> \
  ',

  ForceLogoCheckbox: '\
    <div class="fieldWrapper fieldWrapperCheckbox">\
      <input type="checkbox" name="showLogoCheckbox" />\
      <label for="showLogoCheckbox" class="legacy-text">\
        <@= checkboxLabel @>\
      </label>\
    </div>\
  ',

  DesignerBlock: '\
    <div class="designerBlock"> \
      <div class="designerPhotoBlock"> \
        <img class="designerPhoto" \
          src="<@= designer_picture @>" /> \
      </div> \
      <div class="nameAndLocation"> \
        <p class="text--light"> \
        <@= designer_name @> \
        </p> \
        <p class="text--quaternary designerLocation"> \
        <@= designer_location @> \
        </p> \
      </div> \
    </div>\
  '
};

return {
};

});
